import axios from "axios";
import BASE_URL from "../../config";

const getAuthHeader = () => {
  const tokenData = JSON.parse(localStorage.getItem("authUser") || "{}");
  return {
    Authorization: `Bearer ${tokenData.accessToken}`,
    'Content-Type': 'application/json'
  };
};

export const getRooms = async (filter = {}) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/Room/get`, filter, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching rooms:", error);
    throw error;
  }
};

export const saveRoom = async (room) => {
  const response = await axios.post(`${BASE_URL}/api/Room/save`, room, {
    headers: getAuthHeader(),
  });
  return response.data;
};
